import React,{useEffect} from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { industries } from "../Data";


const Industries=()=>{
    useEffect(() => {
    document.title =
      "Industries | Shivam Transworld";

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "We support transportation needs across manufacturing, exports, MSMEs, FMCG, pharma, and other industries with reliable logistics solutions. Explore now."
      );
    }

      const canonical = document.querySelector("link[rel='canonical']");
  if (canonical) {
    canonical.setAttribute("href", "https://shivamtransworld.in/industries");
  }

  const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      "Industries | Shivam Transworld"
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      "We support transportation needs across manufacturing, exports, MSMEs, FMCG, pharma, and other industries with reliable logistics solutions. Explore now."
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content", "https://shivamtransworld.in/industries");
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://shivamtransworld.in/image/home-about.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
      "Industries | Shivam Transworld"
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
      "We support transportation needs across manufacturing, exports, MSMEs, FMCG, pharma, and other industries with reliable logistics solutions. Explore now."
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://shivamtransworld.in/image/home-about.webp"
    );
  }
  }, []);
    return(
        <>
        <div className="spacing-div"></div>

        {/**industries card */}
         <section className="industry-common-section">
      {/* HEADER */}
      <motion.h1
        className="section-title h1-heading"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        Logistics Solutions for Diverse Industries
      </motion.h1>

      {/* GRID */}
      <motion.div
        className="industry-common-grid"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.12,
            },
          },
        }}
      >
        {industries.map((item, i) => (
          <motion.div
            className="industry-common-card"
            key={i}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              delay: i * 0.1,
              duration: 0.6,
              ease: "easeOut",
            }}
            whileHover={{
              y: -8,
              scale: 1.03,
            }}
          >
             <Link to={`/industries/${item.slug}`} className="service-card-link">
            <motion.div
            className="industry-common-icon"
              initial={{ scale: 0, rotate: -90 }}
              whileInView={{ scale: 1, rotate: 0 }}
              transition={{
                type: "spring",
                stiffness: 250,
                delay: i * 0.1,
              }}
              viewport={{ once: true }}
            >
              {item.icon}
            </motion.div>
            <h2> {item.title.replace(/,/g, ", ")}</h2>
            </Link>
          </motion.div>
        ))}
      </motion.div>
    </section>

   
        </>
    )
}

export default Industries;